import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SocialProofBar from '../components/SocialProofBar';
import PainAmplification from '../components/PainAmplification';
import SolutionShowcase from '../components/SolutionShowcase';
import Features from '../components/Features';
import SocialProof from '../components/SocialProof';
import ComparisonTable from '../components/ComparisonTable';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const LandingPage = () => {
  // Handle hash navigation on page load
  useEffect(() => {
    const hash = window.location.hash;
    
    if (hash) {
      // Wait for page to fully render
      setTimeout(() => {
        const targetId = hash.replace('#', '');
        const element = document.getElementById(targetId);
        
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen font-sans selection:bg-brand-teal selection:text-white">
      <Header />
      <main className="pt-20">
        <Hero />
        <SocialProofBar />
        <PainAmplification />
        <SolutionShowcase />
        
        {/* Features Section - NEEDS ID */}
        <section id="features" className="scroll-mt-20">
          <Features />
        </section>
        
        <SocialProof />
        <ComparisonTable />
        
        {/* Pricing Section - NEEDS ID */}
        <section id="pricing" className="scroll-mt-20">
          <Pricing />
        </section>
        
        {/* Testimonials Section - NEEDS ID */}
        <section id="testimonials" className="scroll-mt-20">
          <SocialProof />
        </section>
        
        {/* FAQ Section - NEEDS ID */}
        <section id="faq" className="scroll-mt-20">
          <FAQ />
        </section>
        
        <FinalCTA />
        <Footer />
      </main>
    </div>
  );
};

export default LandingPage;